import { MatxLoadable } from "matx";
import { authRoles } from "../../../auth/authRoles";

const File = MatxLoadable({
    loader: () =>
        import ("./File")
})

const CaseFileRoutes = [{
    path: "/case/file",
    component: File,
    auth: authRoles.all
}, ];

export default CaseFileRoutes;